import { apiConfig, getApiUrl } from '@configs/apiConfig'

// ** Auth Endpoints
export default {
  loginEndpoint: getApiUrl('/auth/login'),
  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: apiConfig.auth.tokenType,

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: apiConfig.auth.storageTokenKeyName,
  storageRefreshTokenKeyName: apiConfig.auth.storageRefreshTokenKeyName
}
